// extracted by mini-css-extract-plugin
export default {"loader":"AnimatedFetchingComponent-module_loader_f9b23","contain":"AnimatedFetchingComponent-module_contain_ee575"};